<template>
    <div
        :class="{ 'plans-feature': true }"
        v-if="featuresText[value]"
        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
        :content="featuresText[value](features[value])"
    >
        <div class="plans-feature-text">
            <FeatureIcon />
            <span>{{ featuresText[value](features[value]) }}</span>
        </div>
    </div>
</template>
<script>
import { Features } from "./feature-items";
import FeatureIcon from "./svg/FeatureIcon.vue";

export default {
    name: "CardFeatureText",
    components: { FeatureIcon },
    props: {
        value: {
            type: [String, Number, Boolean],
            required: true,
        },
        features: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            featuresText: {
                [Features.AGENT.FREE_AGENT_COUNT]: (val) => `${val} ${this.$t("plans.freeAgent")}`,
                [Features.AGENT.AGENT_COUNT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : val} ${this.$t("headBar.representative")}`,
                [Features.CHATBOT.MAX_SESSION_COUNT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : this.formatNumber(val)} ${this.$t("chatbotv2.chatbot")}`,
                [Features.CHATBOT.INTEGRATION_COUNT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : val} ${this.$t("search.chatbotIntegration")}`,
                [Features.CHATBOT.STORY_COUNT_LIMIT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : val} ${this.$t("plans.chatbotStory")}`,
                [Features.CHATBOT.VERSION_HISTORY_COUNT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : val} ${this.$t("plans.chatbotVersionHistory")}`,
                [Features.CHAT.AUTO_TRANSLATION]: () => this.$t("plans.autoTranslate"),
                [Features.CHAT.VOICE_CALLING]: () => this.$t("billing.audioCallUnlimited"),
                [Features.CHAT.VIDEO_CALLING]: () => this.$t("billing.videoCallUnlimited"),
                [Features.SYSTEM.DATA_PROTECT]: () => this.$t("plans.dataSecurity"),
                [Features.SYSTEM.ACCESS_ALL_AGENT]: () => this.$t("plans.accessibleToAllAgents"),
                [Features.WHATSAPP.NOT_ADDITIONAL_PRICE]: () => this.$t("plans.noExtraCosts"),
                [Features.REPORT.REPORT]: (val) =>
                    val === "basic-report" ? this.$t("plans.normalreporting") : this.$t("plans.detailedReporting"),
                [Features.REPORT.VISITOR_TRACKING]: () => this.$t("plans.instantVisitor"),
                [Features.CHAT.FILE_AND_VOICE_MESSAGE]: () => this.$t("plans.fileAndVoiceShare"),
                [Features.SYSTEM.TEAM_CHAT_ENTEGRATION]: () => this.$t("plans.teamChatIntegration"),
                [Features.SUPPORT.SUPPORT]: (val) =>
                    val === "basic-support" ? this.$t("plans.standardSupport") : this.$t("plans.support"),
                [Features.SUPPORT.SOFTWARE_SUPPORT]: () => this.$t("plans.softwareSupport"),
                [Features.SUPPORT.DEDICATED_CUSTOMER_SUPPORT]: () => this.$t("plans.specialCustomerSupport"),
                [Features.SYSTEM.CHAT_AND_NOTIFICATION]: () => this.$t("plans.chatAndNotifications"),
                [Features.SYSTEM.CHAT_BALLOON_CUSTOMIZATION]: () => this.$t("plans.chatBaloonCustomization"),
                [Features.SYSTEM.REMOVE_SUPSIS_LOGO]: () => `Marka Logosu Kaldırma`,
                [Features.SYSTEM.DATABASE_CONNECTION]: () => this.$t("plans.isolatedDatabaseConnection"),
                [Features.SYSTEM.SINGLE_PANEL_ACCESS]: () => this.$t("plans.onePanelManagement"),
                [Features.SYSTEM.MAX_DISK_SIZE]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : `${val / 1024 / 1024 / 1024}GB`} ${this.$t(
                        "plans.storage"
                    )}`,
                [Features.SYSTEM.TICKET_SYSTEM]: () => this.$t("plans.ticketFeature"),
                [Features.SYSTEM.WHATSAPP_ENTEGRATION]: () => this.$t("whatsappChannel.whatsappIntegration"),
                [Features.SYSTEM.INSTAGRAM_ENTEGRATION]: () => this.$t("plans.instagramIntegration"),
                [Features.SYSTEM.MESSENGER_ENTEGRATION]: () => this.$t("messenger.integrationTitle"),
                [Features.SYSTEM.TELEGRAM_ENTEGRATION]: () => this.$t("plans.telegramIntegration"),
                [Features.TRENDYOL.ENTEGRATION]: () => "Trendyol Entegrasyonu",
                [Features.TRIGGERS.MAX_TRIGGER_COUNT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : val} ${this.$t("plans.smartTrigger")}`,
                [Features.WHATSAPP.BROADCAST_PER_MESSAGE]: (val) => `${val}₺ Toplu Mesaj Başına`,
                [Features.WHATSAPP.BULK_MESSAGE_SENDING]: () => this.$t("plans.broadcastMessaging"),
                [Features.WHATSAPP.MESSAGE_UNREGISTERED_NUMBERS]: () => this.$t("plans.chatWithNonContacts"),
                [Features.WHATSAPP.PERSONALIZED_BROADCAST_MESSAGE]: () => this.$t("plans.personalizedBroadcasts"),
                [Features.CHATBOT.CHATBOT_BUTTON_ACTIVITY]: () => this.$t("plans.automaticChatbotButton"),
                [Features.SYSTEM.CHATBOT_ENTEGRATION]: () => this.$t("wp.chatbotIntegration"),
                [Features.WHATSAPP.CONTROL_WHATSAPP]: () => this.$t("plans.whatsappManaging"),
                [Features.SYSTEM.VISITOR_START_CHAT]: () => this.$t("plans.startChatWithVisitor"),
                [Features.SYSTEM.MAIL_ENTEGRATION]: () => this.$t("plans.mailIntegration"),
                [Features.SYSTEM.SMS_ENTEGRATION]: () => this.$t("plans.smsIntegration"),
                [Features.ARCHIVE.CHAT_ARCHIVE_TIME]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : val / 7} ${this.$t("plans.week")} ${this.$t(
                        "chatbotv2.archive"
                    )}`,
                [Features.CHATBOT.ACTIVE_CHATBOT_LIMIT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : val} ${this.$t("plans.activeChatbot")}`,
                [Features.SYSTEM.READY_CONTENTS]: () => this.$t("plans.readyContents"),
                [Features.SYSTEM.ALL_ENTEGRATION]: () => this.$t("chatbotv2.allIntegrations"),
                [Features.SYSTEM.WEBHOOK_ENTEGRATION]: () => this.$t("plans.webhookIntegration"),
                [Features.SYSTEM.CALENDER_ENTEGRATION]: () => this.$t("plans.calendarIntegration"),
                [Features.SYSTEM.TASK_MANAGEMENT_ENTEGRATION]: () => this.$t("plans.taskManagement"),
                [Features.SYSTEM.AUTO_REZERVATION]: () => this.$t("plans.automaticReservation"),
                [Features.SYSTEM.FLEXIBLE_BILLING]: () => this.$t("plans.flexibleBilling"),
                [Features.CHAT.COPILOT]: () => this.$t("plans.aiAssistant"),
                [Features.REPORT.SPECIAL_REPORT]: () => this.$t("plans.specialReporting"),
                [Features.SYSTEM.PERMISSION_CONTROL]: () => this.$t("plans.confirmationFeature"),
                [Features.WHATSAPP.CHANNEL_COUNT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : val} ${this.$t("whatsappChannel.whatsappChannel")}`,
                [Features.WHATSAPP.BUSINESS_CHANNEL_COUNT]: (val) =>
                    `${val < 0 ? this.$t("plans.unlimited") : val} ${this.$t("plans.businessChannel")}`,
                [Features.MESSENGER.CHANNEL_COUNT]: (val) => `${val < 0 ? this.$t("plans.unlimited") : val} Channel`,
                [Features.INSTAGRAM.CHANNEL_COUNT]: (val) => `${val < 0 ? this.$t("plans.unlimited") : val} Channel`,

                [Features.SERVICES.FLEXIBLE_PRICING]: () => this.$t("plans.flexiblePricing"),
                [Features.SERVICES.UNLIMITED_CB_SCENARIO]: () => this.$t("plans.unlimitedCBScenario"),
                [Features.SERVICES.FREE_FIRST_SCENARIO]: () => this.$t("plans.freeFirstScenario"),
                [Features.SERVICES.RIGHT_TO_CANCEL]: () => this.$t("plans.rightToCancel"),
                [Features.SERVICES.UNLIMITED_LEARN]: () => this.$t("plans.unlimitedLearn"),
                [Features.SERVICES.ALL_PLATFORM_INTEGRATION]: () => this.$t("plans.allPlatformIntegration"),
                [Features.SERVICES.AI_SUPPORT]: () => this.$t("plans.aiSupport"),
                [Features.SERVICES.CREATIVE_AI]: () => this.$t("plans.creativeAI"),
                [Features.SERVICES.UNLIMITED_SESSION]: () => this.$t("plans.unlimitedSession"),
                [Features.SERVICES.ASSISTANT_FROM_WEB]: () => this.$t("plans.assistantFromWebsite"),
                [Features.SERVICES.ASSISTANT_FROM_DOC]: () => this.$t("plans.assistantFromDoc"),
                [Features.SERVICES.MOBILE_APP]: () => this.$t("plans.mobileApp"),
                [Features.SERVICES.WHATSAPP]: () => "Whatsapp",
                [Features.SERVICES.EMAIL]: () => "Email",
                [Features.SERVICES.WEB]: () => "Web",
                [Features.SERVICES.INSTAGRAM]: () => "Instagram",
                [Features.SERVICES.MESSENGER]: () => "Messenger",
                [Features.INSTAGRAM.MANAGE_INBOX]: () => this.$t("plans.manageInbox"),
                [Features.INSTAGRAM.COMMENT_MANAGEMENT]: () => this.$t("plans.commentManagement"),
                [Features.INSTAGRAM.PRIVATE_REPLY_MESSAGE]: () => this.$t("plans.privateReplyMessage"),
                [Features.INSTAGRAM.MENTION_TICKET]: () => this.$t("plans.mentionTicket"),
                [Features.INSTAGRAM.MANAGE_WITH_CHATBOT]: () => this.$t("plans.manageWithChatbot"),
                [Features.TRENDYOL.CHANNEL_COUNT]: (val) => `${val < 0 ? "Sınırsız" : val} Trendyol Kanalı`,
                [Features.TRENDYOL.QUESTION_ANSWER]: () => `Soru Cevap Yönetimi`,
                [Features.TRENDYOL.AUTOMATIC_ANSWER]: () => `Otomatik Cevap Sistemi`,
                [Features.TRENDYOL.COMMENT_CHATBOT_MANAGE]: () => `Chatbot ile Yorum Kontrolü`,
                [Features.AUTOMATION.ENTEGRATION]: () => "Otomasyon Entegrasyonu",
                [Features.AUTOMATION.TASK_FREE_LIMIT]: (val) =>
                    `Her Ay ${this.formatNumber(val)} Ücretsiz Görev Limiti`,
                [Features.AUTOMATION.BLOCK]: (val) => `${val < 0 ? "Sınırsız" : this.formatNumber(val)} Blok Oluşturma`,
                [Features.AUTOMATION.LIMIT]: (val) =>
                    `${val < 0 ? "Sınırsız" : this.formatNumber(val)} Otomasyon Görevi Çalıştırma`,
                [Features.AUTOMATION.EVENT_BASE]: () => "Olay Tabanlı Otomasyon",
                [Features.AUTOMATION.WEBHOOK_BASE]: () => "Webhook Tabanlı Otomasyon",
                [Features.AUTOMATION.BUTTON_BASE]: () => "Buton Tabanlı Otomasyon",
                [Features.AUTOMATION.TIMER_BASE]: () => "Zamanlayıcı Tabanlı Otomasyon",
                [Features.FORM.ENTEGRATION]: () => "Form Entegrasyonu",
                [Features.FORM.LIMIT]: (val) => `${val < 0 ? "Sınırsız" : this.formatNumber(val)} Form Oluşturma`,
                [Features.FORM.FIELD_LIMIT]: (val) => `${val < 0 ? "Sınırsız" : this.formatNumber(val)} Form Alanı`,
                [Features.FORM.SUBMIT_LIMIT]: (val) =>
                    `${val < 0 ? "Sınırsız" : this.formatNumber(val)} Form Gönderimi`,
                [Features.FORM.VIEW_LIMIT]: (val) =>
                    `${val < 0 ? "Sınırsız" : this.formatNumber(val)} Form Görüntüleme`,
                [Features.MAIL.FREE_COUNT]: (val) => `Her Ay İlk ${this.formatNumber(val)} Mail Ücretsiz`,
                [Features.MAIL.COUNT]: (val) =>
                    val < 0 ? "Sınırsız Mail Gönderim/Alım" : `Her Ay ${this.formatNumber(val)} Mail Gönderim/Alım`,
                [Features.MAIL.PER_PRICE]: (val) => `${this.features[Features.MAIL.PER_COUNT]} Mail Başına ${val}₺`,
                [Features.SYSTEM.FREE_AI_TOKEN]: (val) =>
                    `${val < 0 ? "Sınırsız AI Token" : this.formatNumber(val)} Free AI Token`,
                [Features.META_LEAD.CHANNEL_COUNT]: (val) => `${val < 0 ? "Sınırsız" : val} Meta Lead Kanalı`,
                [Features.META_LEAD.AUTOMATION_MANAGE]: () => "Otomasyon Yönetimi",
                [Features.META_LEAD.TICKET_MANAGE]: () => "Ticket Yönetimi",
                [Features.CUSTOMER_TABLES.ENTEGRATION]: () => "Müşteri Tabloları Entegrasyonu",
                [Features.CUSTOMER_TABLES.COUNT]: (val) =>
                    `${val < 0 ? "Sınırsız" : this.formatNumber(val)} Tablo Oluşturma Limiti`,
                [Features.CUSTOMER_TABLES.FIELD_COUNT]: (val) =>
                    `Tablo Başına ${val < 0 ? "Sınırsız" : this.formatNumber(val)} Alan`,
                [Features.CUSTOMER_TABLES.RECORD_COUNT]: (val) =>
                    `Tablo Başına ${val < 0 ? "Sınırsız" : this.formatNumber(val)} Kayıt`,
                [Features.CUSTOMER_TABLES.VIEW_COUNT]: (val) =>
                    `Tablo Başına ${val < 0 ? "Sınırsız" : this.formatNumber(val)} Görüntü`,
                [Features.CUSTOMER_TABLES.LINKED_FEATURE]: () => "Tablo Bağlantı Özelliği",
                [Features.CUSTOMER_TABLES.AI_FEATURE]: () => "AI Destekli Kayıt",
                [Features.SUPPORT.WHATSAPP_BUSINESS_SETUP]: () => "Whatsapp Business Kurulumu",
                [Features.SUPPORT.FACEBOOK_SETUP]: () => "Facebook Kurulumu",
                [Features.SUPPORT.INSTAGRAM_SETUP]: () => "Instagram Kurulumu",
                [Features.SUPPORT.CHATBOT_SETUP]: () => "Chatbot Kurulumu",
                [Features.SUPPORT.AI_SETUP]: () => "AI Kurulumu",
                [Features.SUPPORT.AUTOMATION_SETUP]: () => "Otomasyon Kurulumu",
                [Features.SUPPORT.SPECIAL_PANEL_TRAINING]: () => "Özel Panel Eğitimi",
                [Features.CHAT.LIVE_CHAT]: () => "Canlı Destek",
                [Features.CHAT.LIVE_SCORE]: () => "Canlı İzleme Ekranı",
                [Features.CHAT.MULTIPLE_CHAT_WINDOW]: () => "Çoklu Canlı Destek Ekranı",
                [Features.CHAT.SHARE_SCREEN]: () => "Ekran Paylaşma Özelliği",
                [Features.SUPPORT.CONSULTANCY]: () => "Danışmanlık",
                [Features.SUPPORT.INTEGRATION_SETUP]: () => "Entegrasyon Kurulumu",
                [Features.SUPPORT.STRATEGY_PLANNING]: () => "Strateji Planlama",
                [Features.SYSTEM.TICKET_RECEIVING_LIMIT]: (val) =>
                    `${val < 0 ? "Sınırsız" : this.formatNumber(val)} Destek Talebi`,
                [Features.SYSTEM.READY_CONTENTS_LIMIT]: (val) =>
                    `${val < 0 ? "Sınırsız" : this.formatNumber(val)} Hazır İçerik Oluşturma`,
                [Features.SYSTEM.DEPARTMENT_LIMIT]: (val) =>
                    `${val < 0 ? "Sınırsız" : this.formatNumber(val)} Departman Oluşturma`,
                [Features.SYSTEM.ROLE_LIMIT]: (val) => `${val < 0 ? "Sınırsız" : this.formatNumber(val)} Rol Oluşturma`,
                [Features.SYSTEM.CRM_CONTACT_LIMIT]: (val) =>
                    `${val < 0 ? "Sınırsız" : this.formatNumber(val)} CRM Kişi Limiti`,
                [Features.SYSTEM.CALENDAR_WEB_FEATURE]: () => "Takvim Web Özelliği",
                [Features.TASK.COLUMN_LIMIT]: (val) =>
                    `Çalışma akışı başına ${val < 0 ? "Sınırsız" : this.formatNumber(val)} Görev Aşaması`,
                [Features.TASK.ROW_LIMIT]: (val) =>
                    `Görev sütunu başına ${val < 0 ? "Sınırsız" : this.formatNumber(val)} Görev`,
                [Features.TASK.WORKFLOW_LIMIT]: (val) => `${val < 0 ? "Sınırsız" : this.formatNumber(val)} Görev Akışı`,
                [Features.SERVICES.API_USAGE]: () => "API Kullanımı",
                [Features.SERVICES.EXCEL_DOWNLOAD]: () => "Excel İndirme",
                [Features.SERVICES.CUSTOMER_GROUP]: () => "Müşteri Grubu Oluşturma",
                [Features.SYSTEM.READY_CONTENTS_IMAGE_LIMIT]: () => `Hazır İçerik Resim Yükleme`,
                [Features.SYSTEM.ACCESS_CONTROL]: () => "IP Erişim Kontrolü",
                [Features.MAIL.DETAIL_BROADCAST_REPORT]: () => "Detaylı Broadcast Raporu",
                chipPlans: () => "Uygun Fiyatlı Planlar",
                stableAgentCount: () => "Sabit Temsilci Sayısı",
                stableChannelCount: () => "Sabit Kanal Sayısı",
                uniqEmailContactCount: (val) =>
                    `${val < 0 ? "Sınırsız" : this.formatNumber(val)} Kişiye Mail Gönderimi`,
            },
        };
    },
    methods: {
        formatNumber(number) {
            const currenyFormat = new Intl.NumberFormat("tr");
            if (number <= 100000) return currenyFormat.format(number);
            number = Intl.NumberFormat("tr", { notation: "compact" }).format(number);
            return number.replace(/\s/g, "");
        },
    },
};
</script>
<style lang="scss" scoped>
.plans-feature {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    &-text {
        display: flex;
        align-items: center;
        gap: 3px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        svg {
            min-width: 20px;
            min-height: 20px;
            width: 20px;
            height: 20px;
        }
    }
}
</style>
